import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { FORMS_MODE } from "@comunicare/comunicare-interfaces";

@Injectable({
  providedIn: "root",
})
export class ModalManagementService {
  private readonly ADD_PATIENT_COMPONENT = "AddPatientComponent";

  constructor(private dialog: MatDialog, private router: Router) {}

  public async redirectToGivenModal(modalId: string, source?: string): Promise<void> {
    switch (modalId) {
      case this.ADD_PATIENT_COMPONENT:
        this.router.navigate(["patientRegistration", "patient"], {
          state: {
            mode: FORMS_MODE.CREATE,
            source: source,
          },
        });
        break;
      default:
        await this.router.navigate(["not-found"]);
    }
  }
}
